module.exports = __webpack_public_path__ + "static/img/reports-placeholder.57f84ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reports-placeholder.png
// module id = 67/G
// module chunks = 1